export default function TermsOfServicePage() {
  const lastUpdated = "August 31, 2025";

  return (
    <div className="bg-white dark:bg-gray-900">
      <header className="bg-gray-50 dark:bg-gray-800 py-12">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 dark:text-white">Terms of Service</h1>
          <p className="mt-4 text-lg text-gray-500 dark:text-gray-400">Last updated: {lastUpdated}</p>
        </div>
      </header>
      
      <main className="container mx-auto px-4 py-16 max-w-4xl">
        <div className="prose dark:prose-invert max-w-none text-gray-700 dark:text-gray-300 leading-relaxed">
          <p>
            Welcome to GiveTech totheBlind ("we," "our," or "us"). These Terms of Service ("Terms") govern your use of our website located at [Your Website URL] (the "Service") and form a binding contractual agreement between you, the user of the Service, and us.
          </p>
          <p>
            By using the Service, you acknowledge that you have read and understood these Terms and agree to be bound by them. If you do not agree to these Terms, please do not use the Service.
          </p>

          <h2>1. Description of Service</h2>
          <p>
            GiveTech totheBlind is a platform that facilitates the donation of assistive technology ("Items") from donors ("Donors") to verified blind and visually impaired individuals ("Recipients"). We act as an intermediary to vet Recipients, process donations, procure Items, and facilitate the collection of these Items.
          </p>

          <h2>2. User Accounts and Roles</h2>
          <ul>
            <li><strong>Recipients:</strong> To receive an Item, you must register as a "Recipient," complete an onboarding process, and submit personal information and verification documents. All information provided must be accurate. You agree to collect your funded Item in person from our designated collection center.</li>
            <li><strong>Donors:</strong> You may use the Service as a guest or as a registered "Donor." By donating, you agree that your gift is a non-refundable contribution to fund a specific campaign.</li>
            <li><strong>Administrators ("Admins"):</strong> We reserve the right to manage the platform, including but not limited to, approving/rejecting campaigns, editing campaign text for clarity, and managing user accounts.</li>
          </ul>

          <h2>3. The Campaign and Donation Process</h2>
          <ul>
            <li>Campaign requests submitted by Recipients are subject to review and approval by our Admins. We reserve the right to reject any campaign for any reason.</li>
            <li>Donations are processed through our third-party payment provider, Paystack. We do not store your credit card information.</li>
            <li>A campaign is considered "funded" upon successful payment by a Donor. Once a campaign is funded, the Item is procured and the campaign is closed to further donations.</li>
            <li>All donations are final and non-refundable.</li>
          </ul>

          <h2>4. Recipient Obligations</h2>
          <p>
            As a Recipient, you agree to:
          </p>
          <ul>
            <li>Provide truthful and accurate information during onboarding.</li>
            <li>Travel to our designated collection center in Lagos, Nigeria, to pick up your Item in person.</li>
            <li>Present the original copy of the ID document you uploaded during onboarding for verification at the time of pickup.</li>
            <li>Consent to the recording of a short appreciation video upon receiving your gift, which may be used on our website and social media as a "Success Story."</li>
          </ul>

          <h2>5. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, GiveTech totheBlind shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the Service.
          </p>

          <h2>6. Changes to Terms</h2>
          <p>
            We reserve the right to modify these Terms at any time. We will notify you of any changes by posting the new Terms on this page. You are advised to review these Terms periodically for any changes.
          </p>

          <h2>7. Governing Law</h2>
          <p>
            These Terms shall be governed and construed in accordance with the laws of Nigeria, without regard to its conflict of law provisions.
          </p>
        </div>
      </main>
    </div>
  );
}